"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseWidget = void 0;
const Chart = require("chart.js");
require("chartjs-plugin-labels");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const claim_1 = require("shared/claim");
require("./dispense-widget.less");
let DispenseWidget = class DispenseWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.siteId = 0;
        this.siteIdArray = [];
        this.dispensed = 0;
        this.reversed = 0;
        this.pending = 0;
        this.totalApproved = 0;
        this.intended = 0;
        this.ready = 0;
        this.renderDispenseChart = async () => {
            const data = {
                datasets: [
                    {
                        data: [this.dispensed, this.ready, this.reversed, this.intended],
                        backgroundColor: ["#18c273", "#FCC34A", "#d81b60", "#55DDFB"],
                        borderColor: [
                            "rgba(24, 194, 115, 0.7)",
                            "rgba(252, 195, 74, 1)",
                            "rgba(217, 27, 96, 0.7)",
                            "rgba(85, 221, 251, 1)"
                        ],
                        title: {
                            display: "true",
                            text: "Dispense-rate/30 days"
                        }
                    }
                ],
                // These labels appear in the legend and in the tooltips when hovering different arcs
                labels: ["Dispensed", "Ready To Dispense", "Reversed", "Intended"]
            };
            const options = {
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins: {
                    labels: {
                        render: "percentage",
                        fontColor: "#000000",
                        // fontColor(data: any) {
                        //   const rgb = data.dataset.borderColor[data.index];
                        //   const threshold = 140;
                        //   const luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
                        //   return luminance > threshold ? "black" : "white";
                        // },
                        precision: 2
                    }
                }
            };
            const ctx = this.refs.dispenseWidget;
            ctx.getContext("2d");
            if (this.myPieChart) {
                this.myPieChart.data = data;
                this.myPieChart.update();
            }
            else {
                this.myPieChart = new Chart(ctx, {
                    type: "doughnut",
                    data,
                    options
                });
            }
        };
        /**
         * On Dashboard load, queries for dispense data. When the data is returned then renders Dispense Rate Chart
         */
        this.getDispenseData = async () => {
            const siteId = Array.from(this.siteIdArray);
            // const siteId = usersStore.user.value.siteId;
            const dispensedData = await store_1.dashboardStore.getDispenseStatistics(siteId);
            this.dispensed =
                (dispensedData[claim_1.ClaimStatus.Dispensed] || 0) +
                    (dispensedData[claim_1.ClaimStatus.Refill] || 0) +
                    (dispensedData[claim_1.ClaimStatus.Refilled] || 0) +
                    (dispensedData[claim_1.ClaimStatus.RefillDelayed] || 0) +
                    (dispensedData[claim_1.ClaimStatus.RefillDone] || 0);
            this.reversed = dispensedData[claim_1.ClaimStatus.Reversed] || 0;
            // this.pending = dispensedData[OrderStatus.Pending] || 0;
            this.intended = dispensedData[claim_1.ClaimStatus.Intended] || 0;
            this.ready = dispensedData[claim_1.ClaimStatus.Paid] || 0;
            this.totalApproved = Number(Object.values(dispensedData).reduce((a, b) => a + b, 0));
            await this.renderDispenseChart();
        };
        this.handleChangeSite = async (id) => {
            this.siteId = Number(id);
            this.siteIdArray = [];
            if (this.siteId === 0) {
                this.siteIdArray = store_2.sitesListStore.sites.value.map((site) => {
                    if (!site.testClinic)
                        return site.id;
                }).filter(e => !!e);
                console.log(this.siteIdArray);
            }
            else {
                this.siteIdArray.push(this.siteId);
            }
            await this.getDispenseData();
        };
    }
    get availableOptionsSites() {
        // const options: IMenuItem[] = [];
        // const isImbUser = usersStore.user.value.user;
        // if (isImbUser) {
        //   if (sitesListStore.sites.value) {
        //     options.push({ id: 0, label: "All Pharmacies", value: "0" });
        //     sitesListStore.sites.value.forEach((site, i) => {
        //       const indexStandardizer = 1;
        //       options.push({
        //         id: i + indexStandardizer,
        //         label: site.displayName || site.name,
        //         value: site.id.toString()
        //       });
        //     });
        //   }
        // } else {
        //   const site = usersStore.user.value.site;
        //   const siteOption = {
        //     id: site.id,
        //     label: site.displayName || site.name,
        //     value: site.id.toString()
        //   };
        //   options.push(siteOption);
        // }
        const user = store_3.usersStore.user.value || null;
        const showAllSites = store_3.usersStore.permissions.ReadPharmacies;
        const options = store_2.sitesListStore.sites.value.filter(site => showAllSites || (site === null || site === void 0 ? void 0 : site.id) === (user === null || user === void 0 ? void 0 : user.site.id) || (user === null || user === void 0 ? void 0 : user.sites).includes(site.id))
            .map((site, i) => ({
            id: i + 1,
            label: site.displayName || site.name,
            value: String(site.id)
        }));
        if (true) {
            options.unshift({
                id: 0,
                label: "All Pharmacies",
                value: "0"
            });
        }
        return options;
    }
    async componentDidMount() {
        this.siteId = store_3.usersStore.user.value.siteId;
        this.handleChangeSite(String(this.siteId));
        if (store_3.usersStore.user.value && store_3.usersStore.user.value.user) {
            await store_2.sitesListStore.loadSitesNoRelation();
        }
        this.getDispenseData();
    }
    render() {
        return (React.createElement("div", { className: "dispense-widget widget" },
            store_3.usersStore.permissions.ViewPharmaciesFinancialWidget && (React.createElement("div", { className: "site-dropdown" },
                React.createElement(material_ui_1.Typography, { variant: "title" }, "Currently Viewing"),
                React.createElement(select_1.MaterialSelect, { options: this.availableOptionsSites, required: true, searchable: true, className: "dispense-widget-select-site", label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" }))),
            React.createElement("h4", { className: "total-approved" },
                "Total Approved: ",
                this.totalApproved),
            React.createElement("div", { className: "dispense-widget__canvas-container" },
                React.createElement("canvas", { ref: "dispenseWidget" }))));
    }
};
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "siteIdArray", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "myPieChart", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "dispensed", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "reversed", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "pending", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "totalApproved", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "intended", void 0);
__decorate([
    mobx_1.observable
], DispenseWidget.prototype, "ready", void 0);
__decorate([
    mobx_1.computed
], DispenseWidget.prototype, "availableOptionsSites", null);
DispenseWidget = __decorate([
    mobx_react_1.observer
], DispenseWidget);
exports.DispenseWidget = DispenseWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/dispense-widget/dispense-widget.tsx
// module id = 3348
// module chunks = 0